import { Filter } from "lucide-react";

const ProjectFilters = ({ filters, setFilters }) => {
  const handleChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Status */}
      <select
        name="status"
        value={filters.status}
        onChange={handleChange}
        className="
          px-4
          py-2.5
          rounded-lg
          border
          border-gray-300
          bg-white
          text-sm
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
        "
      >
        <option value="">Status</option>
        <option value="Planning">Planning</option>
        <option value="Active">Active</option>
        <option value="Completed">Completed</option>
        <option value="On Hold">On Hold</option>
      </select>

      {/* Priority */}
      <select
        name="priority"
        value={filters.priority}
        onChange={handleChange}
        className="
          px-4
          py-2.5
          rounded-lg
          border
          border-gray-300
          bg-white
          text-sm
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
        "
      >
        <option value="">Priority</option>
        <option value="Critical">Critical</option>
        <option value="High">High</option>
        <option value="Medium">Medium</option>
        <option value="Low">Low</option>
      </select>

      {/* Execution Mode */}
      <select
        name="executionMode"
        value={filters.executionMode}
        onChange={handleChange}
        className="
          px-4
          py-2.5
          rounded-lg
          border
          border-gray-300
          bg-white
          text-sm
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
        "
      >
        <option value="">Execution Mode</option>
        <option value="Work">Work</option>
        <option value="Hybrid">Hybrid</option>
        <option value="Pipeline">Pipeline</option>
      </select>

      {/* Filter Button (Future Use) */}
      <button
        className="
          flex
          items-center
          gap-2
          px-4
          py-2.5
          rounded-lg
          bg-blue-600
          text-white
          hover:bg-blue-700
          transition
        "
      >
        <Filter size={16} />
        Filters
      </button>
    </div>
  );
};

export default ProjectFilters;